// API configuration settings

// Base URL for API requests
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://ecommerce-api-production-edba.up.railway.app";

// Default request timeout in milliseconds
export const API_TIMEOUT = 10000;